<template>
    
    <time class="date" :datetime="date">{{ format(date) }}</time>

</template>

<script>
import moment from 'moment'

moment.locale('fr')

export default {

    props: {
        date: String,
        time: {
            default: false
        },
        relevantTime: { 
            default: false
        }
    },

    methods: {

        format: function(date) {
            
            if ( !moment(date).isValid()) {
                return "-"
            }

            if (this.time && this.relevantTime) {

                /* On considère que l'horaire n'est pas pertinent s'il est compris entre 0h00 (minuit) inclus et 2h00 (du matin) inclus, heure UTC */
                let timeUTC = moment(date).utc().format('HH:mm')

                if ( ( moment.duration(timeUTC).hours() * 60 * 60 ) + 
                     ( moment.duration(timeUTC).minutes() * 60) <= 7200 ) {

                    this.time = false
                }

            }

            const pattern = this.time ? 'DD/MM/YYYY à HH:mm' : 'DD/MM/YYYY'
            return moment(date).format(pattern)
        }
    }
}
</script>

<style scoped>
.date {
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
}
</style>